var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6648 18.6316L5.73346 21.881C5.25989 22.1271 4.67646 21.9529 4.41538 21.4874V21.4874C4.33985 21.3432 4.2991 21.1833 4.29639 21.0206V6.62241C4.29639 3.87641 6.17282 2.77802 8.87305 2.77802H15.2163C17.8341 2.77802 19.793 3.80319 19.793 6.43934V21.0206C19.793 21.2803 19.6898 21.5294 19.5061 21.7131C19.3224 21.8968 19.0733 22 18.8135 22C18.6479 21.9974 18.485 21.9566 18.3376 21.881L12.3696 18.6316C12.1497 18.5128 11.8847 18.5128 11.6648 18.6316Z",
    stroke: "#C4C4C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36963 9.32266H15.6648",
    stroke: "#C4C4C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.22418694634ec36d8a7ef448690cb4b2.svg";
export { ForwardRef as ReactComponent };